module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow),
      expression: "isShow"
    }]
  }, [_c('audio-video-preview', {
    attrs: {
      "isStartPreview": _vm.isAudioVideo,
      "datas": _vm.$store.state.fileInfo.currentFile
    },
    on: {
      "close": function($event) {
        _vm.close()
      }
    }
  }), _vm._v(" "), _c('imgs-preview', {
    attrs: {
      "isStartPreview": _vm.isImgs,
      "datas": _vm.$store.state.fileInfo.currentFile
    },
    on: {
      "close": function($event) {
        _vm.close()
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b22f8c52","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/preview/preview.vue
// module id = 226
// module chunks = 3